import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import pkg from 'package.json'
declare var $: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  applicationVersion = pkg.version;
  patientpersonalinfo:any;
  // practice_code:any;
  // practice_name:any;
  currentYear: number=new Date().getFullYear();
  isRtl: boolean = false;
  isForReschedule: boolean = false;
  isForLabOrder: boolean = false;
  constructor(private spinner: NgxSpinnerService, private router: Router, private _route: ActivatedRoute, private _login: ExitingpatientService, private _phrutilService: PhrutillsService,private _registor: RegistorpatientService) { 
    //  let info = localStorage.getItem('PatientInfo');
    //   if(!info){
    //     this.router.navigateByUrl("/home");
    //     return;
    //   }
    let isForreschedule = localStorage.getItem('landFrom');
    isForreschedule == "checkin_reschedule" ? this.isForReschedule = true : this.isForReschedule = false;
  }
  
  ngOnInit(): void {
    this._route.queryParams.subscribe((params: Params) => {
      localStorage.clear();
      if (params['practice_code'] != null) {
        this.VerifyPractice(params['practice_code']);
        if (params['lf'] != null && params['lf'] == 'qrcode') {
          localStorage.setItem("landFrom", params['lf']);
        }
        if (params['lf'] != null && params['lf'] == 'drsite') {
          localStorage.setItem("landFrom", params['lf']);
        }
        
        if (params['labid'] != null) {
          this.isForLabOrder = true;
          localStorage.setItem("labid", params['labid']);
        }
        if (params['from'] != null) {
            localStorage.setItem("from", params['from']);
        }
      }
      else {
        $("#isNotValid_linkexiting").modal("show");
        return;
      }
    }, (error:any) => {
      localStorage.clear();
      $("#isNotValid_linkexiting").modal("show");
      return;
    });

    this._phrutilService.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.isRtl = false;
        this._phrutilService.setTitle('Breeze Check-in');
      } else if (language === 'hi') {
        this.isRtl = false;
        this._phrutilService.setTitle('Breeze Check-in');
      } else if (language === 'ur') {
        this.isRtl = true;
        this._phrutilService.setTitle('Breeze Check-in');
      }else if (language === 'gu') {
        this.isRtl = false;
        this._phrutilService.setTitle('Breeze Check-in');
      }
      else {
        this.isRtl = false;
        this._phrutilService.setTitle('Breeze Check-in');
      }
    });

  // this._phrutilService.setTitle('Breeze Check-in');
    //this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
  }
  SelectPatientOption(selectedOption: any) {
    
    this.patientpersonalinfo.type=selectedOption;
    let data = this._phrutilService.encrypt(this.patientpersonalinfo);
    localStorage.setItem('PatientInfo', data);
    if (selectedOption == 'check-in') {
      this.router.navigateByUrl('/securelogin');
    }
    else if (selectedOption == 'walkin')
    {
     // this.router.navigate(['/securelogin'], {queryParams: {'type': 'appointment'}});
     this.router.navigateByUrl("/exitingappointment");
    }
    else if (selectedOption == 'payment')
    {
      this.router.navigate(['/securelogin'], {queryParams: {'type': 'payment'}});
    }
    
  }
  
  VerifyPractice(practice_code :any) {
    this.spinner.show();
    this._registor.VerifyPracticeCode(practice_code).subscribe((res:any) => {
      this.spinner.hide();
      if(res.data && res.statusCode==200)
      {
        this.patientpersonalinfo = res.data;
        this.patientpersonalinfo.practice_name = res.data.prac_Name;
        this.patientpersonalinfo.practice_code = res.data.practice_Code;
        const landfrom = localStorage.getItem("landFrom");
        localStorage.setItem('pracName', this.patientpersonalinfo.practice_name);
        this._phrutilService.setNavpracName(this.patientpersonalinfo.practice_name);
        console.log(landfrom);
        if (landfrom =='qrcode') {
          this.patientpersonalinfo.type = 'check-in';
          let data = this._phrutilService.encrypt(this.patientpersonalinfo);
          localStorage.setItem('PatientInfo', data);
          this.router.navigateByUrl('/securelogin');
        }
        if (landfrom == 'drsite') {
          this.patientpersonalinfo.type = 'walkin';
          let data = this._phrutilService.encrypt(this.patientpersonalinfo);
          localStorage.setItem('PatientInfo', data);
          this.router.navigateByUrl('/exitingappointment');
        }
        
        if (this.isForLabOrder) {
          this.patientpersonalinfo.type = 'laborder';
          let data = this._phrutilService.encrypt(this.patientpersonalinfo);
          localStorage.setItem('PatientInfo', data);
          this.router.navigate(['/securelogin'], { queryParams: { 'type': 'laborder' } });
        }
      }
      else
      {
        $("#isNotValid_linkexiting").modal("show");
        return;
      }
    },
    (error:any) => {
      this.spinner.hide();
      $("#isNotValid_linkexiting").modal("show");
    });
  }
  RegistorNewPatient()
  {
    this.router.navigateByUrl('/login?practice_code='+this.patientpersonalinfo.practice_code);
  }
}
